import React from 'react';

import LoadingSpinner from 'src/components/LoadingSpinner';
import {Dims, Margin} from 'src/lib/commonTypes';

type Props = {
  dims: Dims;
  margin: Margin;
  type?: 'border' | 'bg';
};

export default function VizLoading({dims, margin, type = 'bg'}: Props) {
  let typeClassNames = '';
  if (type === 'border') {
    typeClassNames = 'border border-gray-500';
  } else if (type === 'bg') {
    typeClassNames = 'bg-gray-50';
  }

  return (
    <div
      style={{
        paddingTop: margin.top,
        paddingRight: margin.right,
        paddingBottom: margin.bottom,
        paddingLeft: margin.left,
      }}
    >
      <div
        style={{
          width: dims[0] - margin.left - margin.right,
          height: dims[1] - margin.top - margin.bottom,
        }}
        className={`${typeClassNames} flex justify-center items-center`}
      >
        <LoadingSpinner />
      </div>
    </div>
  );
}
